import emailjs from "emailjs-com";
import React, { useState } from "react";
import Phone_icon from "../../assets/images/svg/call_icon.svg";
import edit_icon from "../../assets/images/svg/edit_icon.svg";
import eamil_icon from "../../assets/images/svg/email_icon.svg";
import user_icon from "../../assets/images/svg/user_icon.svg";

const PlanContact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    organization: "",
    phone: "",
    city: "",
    eventType: "",
    eventDate: "",
    budget: "",
    guests: "",
    message: "",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showAdmission, setShowAdmission] = useState(false);
  const [subjectOptions, setSubjectOptions] = useState([
    "Feedback",
    "Support",
    "Business Development",
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "message") {
      const wordCount = value.trim().split(/\s+/).length;
      if (wordCount > 150) {
        setErrorMessage("Message cannot exceed 150 words.");
        return;
      } else {
        setErrorMessage("");
      }
    }

    // Update "Subject" options based on "Vertical"
    if (name === "vertiale") {
      if (value === "Skilling") {
        setSubjectOptions((prevOptions) => {
          // Add "Admission" only if it doesn't already exist
          return prevOptions.includes("Admission")
            ? prevOptions
            : [...prevOptions, "Admission"];
        });
      } else {
        // Reset to default options when "Skilling" is not selected
        setSubjectOptions(["Feedback", "Support", "Business Development"]);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_bzm9a1n", // Replace with your EmailJS Service ID
        "template_fexwsif", // Replace with your EmailJS Template ID
        formData,
        "YKCytqrtQ0SjktFaQ" // Replace with your EmailJS User ID
      )
      .then(
        (response) => {
          setSuccessMessage("Message sent successfully!");
          setErrorMessage("");
          setFormData({
            name: "",
            email: "",
            organization: "",
            phone: "",
            city: "",
            eventType: "",
            eventDate: "",
            budget: "",
            guests: "",
            message: "",
          });
        },
        (err) => {
          setErrorMessage("Failed to send message. Please try again.");
          setSuccessMessage("");
        }
      );
  };

  return (
    <div className="py-5" style={{ backgroundColor: "transparent" }}>
      <div className="container">
        <h3 className="text-center fs_30 fw-semibold" style={{ color: "#f8fafc" }}>
          Tell us about your event
        </h3>
        <div className="row justify-content-center pt-3">
          <div className="col-lg-6 mt-4 mt-lg-0">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Name */}
                <div className="col-md-6">
                  <div
                    className="d-flex border border-1 border-white text-white rounded-1 py-2 px-3"
                    style={{ backgroundColor: "#262626" }}
                  >
                    <input
                      required
                      style={{ color: "white" }}
                      className="bg-transparent w-100 border-0 px-2 text-white ff_s"
                      placeholder="Name"
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Email */}
                <div className="col-md-6 mt-4 mt-md-0">
                  <div
                    className="d-flex border border-1 border-white text-white rounded-1 py-2 px-3"
                    style={{ backgroundColor: "#262626" }}
                  >
                    <input
                      required
                      style={{ color: "white" }}
                      className="bg-transparent w-100 border-0 px-2 text-white ff_s"
                      placeholder="Email"
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Organization Name */}
                <div className="col-md-6 mt-4">
                  <div
                    className="d-flex border border-1 border-white text-white rounded-1 py-2 px-3"
                    style={{ backgroundColor: "#262626" }}
                  >
                    <input
                      style={{ color: "white" }}
                      className="bg-transparent w-100 border-0 px-2 text-white ff_s"
                      placeholder="Organization Name (if any)"
                      type="text"
                      name="organization"
                      value={formData.organization || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Contact Number */}
                <div className="col-md-6 mt-4">
                  <div
                    className="d-flex border border-1 border-white text-white rounded-1 py-2 px-3"
                    style={{ backgroundColor: "#262626" }}
                  >
                    <input
                      required
                      style={{ color: "white" }}
                      className="bg-transparent w-100 border-0 px-2 text-white ff_s"
                      placeholder="Contact Number"
                      type="number"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* City of Event */}
                <div className="col-md-6 mt-4">
                  <div
                    className="d-flex border border-1 border-white text-white rounded-1 py-2 px-3"
                    style={{ backgroundColor: "#262626" }}
                  >
                    <input
                      style={{ color: "white" }}
                      className="bg-transparent w-100 border-0 px-2 text-white ff_s"
                      placeholder="City of Event"
                      type="text"
                      name="city"
                      value={formData.city || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Preferred Event Type */}
                <div className="col-md-6 mt-4">
                  <select
                    required
                    name="eventType"
                    value={formData.eventType || ""}
                    style={{
                      backgroundColor: "#262626",
                      color: formData.eventType ? "white" : "#939393", // white when selected, orange when not
                    }}
                    onChange={handleChange}
                    className={`d-flex border w-100 border-1 cursor-pointer rounded-1 py-2 px-3 select-options ${
                      formData.eventType ? "select-normal" : "select-warning"
                    }`}
                  >
                    <option value="" disabled>
                      Preferred Event Type
                    </option>
                    <option value="Entertainment Shows" className="text-white">
                      Entertainment Shows
                    </option>
                    <option value="Corporate Events" className="text-white">
                      Corporate Events
                    </option>
                    <option
                      value="Government Events
"
                      className="text-white"
                    >
                      Government Events
                    </option>
                    <option value="Theme Events" className="text-white">
                      Theme Events
                    </option>
                  </select>
                </div>

                {/* Date(s) of Event */}
                <div className="col-md-6 mt-4">
                  <div
                    className="d-flex border border-1 border-white text-white rounded-1 py-2 px-3"
                    style={{ backgroundColor: "#262626" }}
                  >
                    <input
                      style={{ color: "white" }}
                      className="bg-transparent w-100 border-0 px-2 text-white ff_s"
                      placeholder="Date(s) of Event"
                      type="text"
                      name="eventDate"
                      value={formData.eventDate || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Estimated Budget */}
                <div className="col-md-6 mt-4">
                  <div
                    className="d-flex border border-1 border-white text-white rounded-1 py-2 px-3"
                    style={{ backgroundColor: "#262626" }}
                  >
                    <input
                      style={{ color: "white" }}
                      className="bg-transparent w-100 border-0 px-2 text-white ff_s"
                      placeholder="Estimated Budget"
                      type="text"
                      name="budget"
                      value={formData.budget || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Number of Guests */}
                <div className="col-12 mt-4">
                  <div
                    className="d-flex border border-1 border-white text-white rounded-1 py-2 px-3"
                    style={{ backgroundColor: "#262626" }}
                  >
                    <input
                      style={{ color: "white" }}
                      className="bg-transparent w-100 border-0 px-2 text-white ff_s"
                      placeholder="Number of Guests Expected"
                      type="number"
                      name="guests"
                      value={formData.guests || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Additional Notes */}
                <div className="col-12 mt-4 position-relative">
                  <div
                    className="d-flex border border-1 border-white text-white rounded-1 py-2 ps-0 px-3"
                    style={{ backgroundColor: "#262626" }}
                  >
                    <img
                      className="position-absolute ps-3 pt-3 top-0"
                      src={edit_icon}
                      alt="edit icon"
                    />
                    <textarea
                      required
                      rows={6}
                      style={{ color: "white" }}
                      className="bg-transparent ps-4 ms-3 w-100 border-0 px-2 text-white ff_s"
                      placeholder="Additional Notes or Vision"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div>
                  {successMessage && (
                    <p className="text-success mt-3">{successMessage}</p>
                  )}
                  {errorMessage && (
                    <p className="text-danger mt-3">{errorMessage}</p>
                  )}
                </div>

                <div className="d-flex justify-content-center pt-4">
                  <button
                    className="but px-5 py-3  rounded-2 border-0 text-white mt-3 fs_14 ff_s fw-bold"
                    type="submit"
                  >
                    Let’s Get Started
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanContact;
